var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar',{staticClass:"xl:grid tt-bg-light"}),_c('Menu'),_c('SearchBlock',{staticClass:"mt-28"}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }